import { getNoCatch, postNoCatch } from '@api/request';

const prefix = '/api/purmaterial_orders';
export const api = {
  get_rmaterial_orders: params => getNoCatch(`${prefix}/get_rmaterial_orders`, params),
  get_rmaterial_orders_by_id: params => getNoCatch(`${prefix}/get_rmaterial_orders_by_id`, params),
  edit_rmaterial_orders: params => postNoCatch(`${prefix}/edit_rmaterial_orders`, params),
  generateQRCode: params => postNoCatch(`${prefix}/generateQRCode`, params),
  getQRCodeList: params => getNoCatch(`${prefix}/getQRCodeList`, params),
  order_issuance: params => postNoCatch(`${prefix}/order_issuance`, params),
  order_becomes_invalid: params => postNoCatch(`${prefix}/order_becomes_invalid`, params),
  getPush9008Count: params => getNoCatch(`${prefix}/getPush9008Count`, params),
  getPush9008List: params => getNoCatch(`${prefix}/getPush9008List`, params),
  editPush9008: params => postNoCatch(`${prefix}/editPush9008`, params)
};
